import { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import { useHistory } from "react-router-dom";
import { offices } from "../../data/offices";
import "./styles.scss";

const Mapa = () => {
	const history = useHistory();
	const shouldReduceMotion = useReducedMotion();
	const [activeIndex, setActiveIndex] = useState(0);
	const [isPaused, setIsPaused] = useState(false);
	const activeOffice = offices[activeIndex];

	useEffect(() => {
		if (shouldReduceMotion || isPaused) {
			return undefined;
		}

		const interval = setInterval(() => {
			setActiveIndex((current) => (current + 1) % offices.length);
		}, 4500);

		return () => clearInterval(interval);
	}, [isPaused, shouldReduceMotion]);

	const goToOffice = () => {
		history.push(`/oficinas?oficina=${activeOffice.slug}`);
	};

	return (
		<section
			id="mapa"
			onMouseEnter={() => setIsPaused(true)}
			onMouseLeave={() => setIsPaused(false)}
			onFocus={() => setIsPaused(true)}
			onBlur={() => setIsPaused(false)}
		>
			<div className="mapa_panel">
				<p className="route_label">COBERTURA / COLOMBIA</p>
				<h2>Rutas conectadas desde cuatro puntos estratégicos.</h2>
				<p className="mapa_copy">
					Selecciona una ciudad para revisar la sede, dirección y acceso directo al mapa.
				</p>

				<div className="route_list" aria-label="Seleccionar ciudad de cobertura">
					{offices.map((office, index) => (
						<button
							type="button"
							key={office.slug}
							onClick={() => setActiveIndex(index)}
							className={activeOffice.id === office.id ? "active" : ""}
						>
							<span className="node" />
							<span>
								<strong>{office.shortName}</strong>
								<small>{office.dir}</small>
							</span>
						</button>
					))}
				</div>

				<button type="button" className="mapa_cta" onClick={goToOffice}>
					Ver oficina {activeOffice.shortName}
					<FaArrowRight />
				</button>
			</div>

			<div
				className="map_sheet"
				onClick={goToOffice}
				onKeyDown={(event) => {
					if (event.key === "Enter" || event.key === " ") {
						goToOffice();
					}
				}}
				role="button"
				tabIndex="0"
				aria-label={`Ver oficina ${activeOffice.shortName}`}
			>
				<div className="sheet_meta">
					<span>FKG-{String(activeOffice.id).padStart(2, "0")}</span>
					<span>{activeOffice.name}</span>
				</div>
				<div className="map_frame">
					<AnimatePresence exitBeforeEnter>
						<motion.img
							key={activeOffice.slug}
							src={activeOffice.mapImage}
							alt={`Mapa de ${activeOffice.shortName}`}
							loading="lazy"
							initial={shouldReduceMotion ? false : { opacity: 0, x: 14 }}
							animate={{ opacity: 1, x: 0 }}
							exit={{ opacity: 0, x: -10 }}
							transition={{ duration: 0.28, ease: "easeOut" }}
						/>
					</AnimatePresence>
				</div>
			</div>
		</section>
	);
};

export default Mapa;
